
import gql from 'graphql-tag';

const GET_APPLICATIONS = gql`
  query applications ($constraints: ApplicationInput!, $filter: String, $skip: Int, $limit: Int) {
    applications (constraints: $constraints, filter: $filter, skip: $skip, limit: $limit) {
      applicationName,
      applicationID,
      developerID,
      jwtTokenExpiration,
      jwtServerTokenExpiration,
      clientTokenScopes,
      serverTokenScopes,
      clientID,
      clientSecret,
      privateKey,
      publicKey,
      domain,
      federationType,
      version,
      appType,
      childAppName,
      jwtOAuth2TokenExpiration,
      oauth2TokenScopes,
      oauth2FriendlyName,
      oauth2RedirectURI,
      jwtOAuth2ServerTokenExpiration,
      oauth2ServerTokenScopes,
      oauth2ShouldValidateEmail,
    }
  }
`;

const getAllApplications = gql`
query allApplications($filter: String!, $skip: Int, $limit: Int, $owner: String!) {
  allApplications(filter: $filter, skip: $skip, limit: $limit, owner:$owner) {
    applications{
      fields {
        applicationName
        applicationID
        developerID
        jwtTokenExpiration
        jwtServerTokenExpiration
        clientTokenScopes
        serverTokenScopes
        clientID
        clientSecret
        privateKey
        publicKey
        domain
        federationType
        version
        appType
        childAppName
        jwtOAuth2TokenExpiration
        oauth2TokenScopes
        oauth2FriendlyName
        oauth2RedirectURI
        jwtOAuth2ServerTokenExpiration
        oauth2ServerTokenScopes
        oauth2ShouldValidateEmail
      },
      ownerID,
      createdBy,
      createAt,
      updatedAt,
      className,
    },
    count,
  }
}
`;

const GET_ALL_APPLICATION_COUNT = gql`
  query allApplicationCount ($filter: String!) {
    allApplicationCount (filter: $filter)
  }
`;

const GET_USER_APPLICATION_COUNT = gql`
  query userApplicationCount {
    userApplicationCount {
      applicationCount
    }
  }
`;

const DOMAIN_AVAILABLE = gql`
  query domainAvailable ($domain: String!) {
    domainAvailable (domain: $domain)
  }
`;

const SEARCH_DOMAINS = gql`
  query searchDomains ($search: String!) {
    searchDomains (search: $search)
  }
`;

const UPSERT_APPLICATION = gql`
  mutation application ($application: ApplicationInput!, $currentTeam: String!) {
    application (application: $application, currentTeam: $currentTeam) {
      applicationName,
      applicationID,
      developerID,
      jwtTokenExpiration,
      jwtServerTokenExpiration,
      clientTokenScopes,
      serverTokenScopes,
      clientID,
      clientSecret,
      privateKey,
      publicKey,
      domain,
      federationType,
      version,
      appType,
      childAppName,
      jwtOAuth2TokenExpiration,
      oauth2TokenScopes,
      oauth2FriendlyName,
      oauth2RedirectURI,
      jwtOAuth2ServerTokenExpiration,
      oauth2ServerTokenScopes,
      oauth2ShouldValidateEmail,
    }
  }
`;

export {
  GET_APPLICATIONS,
  GET_ALL_APPLICATION_COUNT,
  GET_USER_APPLICATION_COUNT,
  getAllApplications,
  UPSERT_APPLICATION,
  SEARCH_DOMAINS,
  DOMAIN_AVAILABLE,
};
